import React, { FC, useState } from "react";
import styled from "styled-components";
import { Row, Form, Input, Col } from "antd";
import { useStoreState, useStoreActions } from '../myStore/index';
import HeaderComponent from "../Components/HeaderComponents";
import FooterPublic3D from "../Components/FooterPublic3D";
import { PrimaryButtonX } from "../Components/Button3D";
import { useHistory } from "react-router-dom";
import { SmallText } from "../Components/Text3D";
import Img3D from "../Components/Model3D";

const MainContainer = styled(Row)`
`;
const ContentDiv = styled.div`
  width: 100%;
  margin-top: 2rem;
  /* padding-bottom: 2rem; */
`;
const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1.2rem;
`;

const ImgDiv = styled.div`
  // height: 100%;
  // width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const image3dStyle = {
  top: 0,
  right: 0,
  alignItems: "center",
  height: "400px",
  width: "320px",
};
const InfoText = styled.span`
  color: #1890ff;
`;

const OtherInfoPage: FC = () => {
    const history = useHistory()
    const currentItem = useStoreState((state: any) => state.cart.currentItem);
    const setCurrentItem = useStoreActions((actions: any) => actions.cart.setCurrentItem);
    const [form] = Form.useForm();
    const [currentDesignIdx, setCurrentDesignIdx] = useState(0);
    const [showMsg, setShowMsg] = useState(true);
    const handleNextClick = (values: any) => {
        let items = currentItem;
        const { designThumbnail } = items[currentDesignIdx];
        items[currentDesignIdx]["designName"] = values.designName;
        items[currentDesignIdx]["description"] = values.designName;
        items[currentDesignIdx]["summary"] = values.designName;
        items[currentDesignIdx]["designThumbnail"] = !designThumbnail
          ? values.thumbnailImage
          : designThumbnail;
          setCurrentItem(items);
        if(currentDesignIdx >= items.length-1 ){
            history.push("/design/quantity");
            return;
        }
        setShowMsg(true);
        setCurrentDesignIdx(currentDesignIdx + 1)
        form.resetFields();
    }

    const getLocalImageUrl = (item) => {
      return URL.createObjectURL(item.files[0].originFileObj);
    };

    const setThumbnailImage = (imageUrl) => {
      form.setFieldsValue({ thumbnailImage: imageUrl });
      setShowMsg(false)
    };

    return (
      <>
        <MainContainer>
          <HeaderComponent />
          <ContentDiv>
            <Col span={20} offset={2}>
              <TopSection>
                <SmallText>
                  Add details of your design 
                  <strong>
                    (
                    {currentItem[currentDesignIdx]["designName"] ||
                      currentItem[currentDesignIdx]["files"][0]["name"]}
                    )
                  </strong>
                </SmallText>
              </TopSection>
              <Form
                form={form}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleNextClick}
                initialValues={{}}
                autoComplete="off"
              >
                <Row>
                  <Col md={{ span: 14 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item
                      label="Design Name"
                      name="designName"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Design Name!",
                        },
                      ]}
                    >
                      <Input
                        style={{ height: "40px" }}
                        placeholder="Enter your design name"
                      />
                    </Form.Item>
                    <Form.Item
                      name="thumbnailImage"
                      hidden
                      rules={[
                        {
                          required: true,
                          message: "Please wait for thumbnail",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="description">
                      <Input.TextArea placeholder="Write some description about your design" />
                    </Form.Item>
                    <Form.Item label="Summary" name="summary">
                      <Input.TextArea rows={5} placeholder="Write summary" />
                    </Form.Item>
                    {showMsg && (
                      <InfoText>
                        Please wait for a model to render in the left.
                      </InfoText>
                    )}
                  </Col>
                  <Col
                    md={{ span: 9, offset: 1 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                  >
                    <ImgDiv>
                      <Img3D
                        url={
                          !!currentItem[currentDesignIdx]["designUrl"]
                            ? currentItem[currentDesignIdx]["designUrl"]
                            : getLocalImageUrl(currentItem[currentDesignIdx])
                        }
                        style={image3dStyle}
                        autoScreenshot
                        setThumbnailImage={setThumbnailImage}
                      />
                    </ImgDiv>
                  </Col>
                </Row>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Form.Item>
                    <PrimaryButtonX
                      type="primary"
                      style={{ margin: "0.5rem 0" }}
                      htmlType="submit"
                    >
                      next
                    </PrimaryButtonX>
                  </Form.Item>
                </div>
              </Form>
            </Col>
          </ContentDiv>
          <FooterPublic3D />
        </MainContainer>
      </>
    );
};

export default OtherInfoPage;